import { computed, toValue } from "vue";
import { useBuiltComponentStore } from "..";
export const useBuiltComponentSet = (componentIds) => {
    const builtComponentStore = useBuiltComponentStore();
    const builtComponentSet = computed(() => {
        const output = [];
        const componentIdsValue = toValue(componentIds);
        if (!componentIdsValue) {
            return output;
        }
        for (const componentId of componentIdsValue) {
            const component = builtComponentStore.getBuiltComponent(componentId);
            if (component) {
                output.push(component);
            }
            else {
                builtComponentStore.fetchBuiltComponent(componentId);
            }
        }
        return output;
    });
    return {
        builtComponentSet,
    };
};
